import React, { useEffect, useState } from 'react'
import AdminTemplate from "../../../../components/admin/layouts/Template.js";
import ContentWrapper from "../../../../components/common/ContentWrapper.js";
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import EdPaperList from './FindPaperTabs/EdPaperList.js';
import EdCMCPaperList from '../cmc/FindPaperTabs/EdCMCPaperList.js';
import EdEnrolledPaperList from '../../../candidate/EdEnrolledPaperList.js';
import EdCMCEnrolledPaperList from '../../../candidate/EdCMCEnrolledPaperList.js';
import config from '../../../../helper/config.js';
import { CombankService } from "../../../../service/manage/subscription/combank_pg.service.js";
import { sweetStatusAlert, sweetConfirmAlert } from "../../../../components/common/SweetAlert.js";
import { customerConstants } from '../../../../helper/constants.js';
import { useLocation } from 'react-router-dom';
import Spinner from "../../../../components/Spinner3.js";

import "./EdSiderFindExams.css";
import { history } from "../../../../helper/history";
import { routes } from "../../../../helper/routes";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

const customer = getCustomerFeatureFlag();
let customerPaperText, PaperList, EnrolledPaperList;
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    PaperList = EdPaperList;
    EnrolledPaperList = EdEnrolledPaperList;
    customerPaperText = "Exams";
    break;
  case customerConstants.EXO_CUSTOMER2:
    PaperList = EdCMCPaperList;
    EnrolledPaperList = EdCMCEnrolledPaperList;
    customerPaperText = "Past Papers";
    break;
  case customerConstants.EDF_CUSTOMER3:
    PaperList = EdPaperList;
    EnrolledPaperList = EdEnrolledPaperList;
    customerPaperText = "Courses";
    break;
  default:
    PaperList = EdPaperList;
    EnrolledPaperList = EdEnrolledPaperList;
    customerPaperText = "Search";
    break;
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function EdSiderFindPapers() {

  const location = useLocation();
  const [value, setValue] = useState(location.state?.value || 0);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    // Debug log to detect navigation without full refresh
    // eslint-disable-next-line no-console
    console.log("EdSiderFindExams mounted or location changed", location.state);
    setValue(location.state?.value || 0);
  }, [location]); const [availablePaperControl, setAvailablePaperControl] = useState(false);
  const [enrollPaperControl, setEnrollPaperControl] = useState(false);

  const [paperListState, setPaperListState] = useState(
    {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      breadcrumb2: "student",
      nodeTitle: "",
      mid: 108,
      main_table_id: 3,
      flg_list_active: null,
      owner_restriction: "True",
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null,
      user_list_table_id: sessionStorage.getItem("table_log_id"),
    }
  )

  const handlePaymentResponse = () => {
    const query = new URLSearchParams(window.location.search);
    const success = query.get('success');
    const cancel = query.get('cancel');
    const userType = sessionStorage.getItem("userType");

    if (success === 'true') {
      setIsLoading(true);
      if (customerConstants.EXO_CUSTOMER2 === getCustomerFeatureFlag()) {
        query.delete('success');
        sweetStatusAlert("Success!", "Your payment was successful!", "success").then(() => {
          setValue(1);
          updateUrl(query);
          setIsLoading(false);
        });
      } else {
        CombankService.retrieveOrderForAssessment(sessionStorage.getItem("checkout_session_id"))
          .then((response) => {
            sessionStorage.removeItem('checkout_session_id');
            query.delete('success');
            sweetStatusAlert("Success!", "Your payment was successful!", "success").then(() => {
              setValue(1);
              updateUrl(query);
            });
            updateUrl(query);
            setIsLoading(false);
          });
      }
    } else if (cancel === 'true') {
      query.delete('cancel');
      sweetStatusAlert("", "You are back to EdSider Exams!", "info");
      updateUrl(query);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const updateUrl = (query) => {
    const newQueryString = query.toString();
    const newUrl = newQueryString ? window.location.pathname + '?' + newQueryString : window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    handlePaymentResponse();
    setPaperListState(
      {
        privilege_edit: 1,
        privilege_add: 1,
        privilege_delete: 1,
        breadcrumb2: "student",
        nodeTitle: "",
        mid: 108,
        flg_list_active: null,
        main_table_id: 3,
        owner_restriction: "True",
        lg_user_id: sessionStorage.getItem("manage_user_id"),
        lg_user_table_id: sessionStorage.getItem("table_log_id"),
        user_list_restriction: "True",
      }
    )

  }, [])





  return (

    <AdminTemplate>

      <ContentWrapper>
        <div className="ed-exams-page-content">
          {/* Exams header moved into `ExamsHeaderTabs` component (rendered inside filter layout). */}
          {/* Back button preserved as comment:
          <div className="ed-exams-header">
            <div className="ed-exams-right">
              <button className="back-to-dashboard-btn" onClick={() => history.push(routes.manage_dashboard)}><KeyboardBackspaceIcon /></button>
            </div>
          </div>
          */}

          {isLoading ? (
            <div className="loading-container mb-5 mt-10">
              <Spinner id="show" text="Please wait..." />
            </div>
          ) : (
            <Box sx={{ width: '100%' }}>
              {/* Tabs moved to `ExamsHeaderTabs` component (rendered inside filter layout). */}

              <Box
                sx={{
                  /* allow outer container to scroll; internal box height auto */
                  height: 'auto',
                  minHeight: '70vh',
                  overflow: 'visible',
                }}
              >

                <CustomTabPanel value={value} index={0}>
                  <PaperList
                    state={paperListState}
                    controller={setAvailablePaperControl}
                    handleChange={handleChange}
                    showHeader={true}
                    value={value}
                    customerPaperText={customerPaperText}
                    availablePaperControl={availablePaperControl}
                    enrollPaperControl={enrollPaperControl}
                  />
                </CustomTabPanel>

                <CustomTabPanel value={value} index={1}>
                  <EnrolledPaperList
                    state={paperListState}
                    controller={setEnrollPaperControl}
                    selectedCandidateStatus={location.state?.candidateStatus || "null"}
                    paperStatus={location.state?.paperStatus || "All"}
                    candidateId={location.state?.candidateId || 'null'}
                    showHeader={true}
                    value={value}
                    handleChange={handleChange}
                    customerPaperText={customerPaperText}
                    availablePaperControl={availablePaperControl}
                    enrollPaperControl={enrollPaperControl}
                  />
                </CustomTabPanel>
              </Box>
            </Box>
          )}

        </div>
      </ContentWrapper>

    </AdminTemplate>

  )
}